export default __webpack_public_path__ + "resources/icons/n241-e0b1.webp";